'use client';

import { CwitnesscardAnimated } from './CwitnesscardAnimated';
import { CwitnesscardStatic } from './CwitnesscardStatic';
import type { CwitnesscardProps, WitnessCardData } from './Cwitnesscard.types';

export type { CwitnesscardProps, WitnessCardData };

export function Cwitnesscard(props: CwitnesscardProps) {
  if (props.isMobileMotion) {
    return <CwitnesscardStatic {...props} />;
  }

  return <CwitnesscardAnimated {...props} />;
}
